'use strict';

/*
DOCUMENT ME. Nope!
*/

define('modules/module.inventory.specific',[
  'jquery',
  './module',
  'txt!./module.inventory.hbs',
  'txt!./module.static.hbs',
  'txt!./module.loader.hbs',
  'lib/page-cache',
  'lib/services/inventory-service',
  'lib/transforms/inventory.tmpl.module',
  'lib/services/3dimages',
  'components/slicker',
  'storageUtil',
  'lib/util/tda.config',
  'zipTools',
  'lib/util/zip',
  './module.inventory.generic',
  'cookies',
], function (
  $,
  Module,
  txtTemplate,
  txtStatic,
  txtModuleLoader,
  PageCache,
  inventoryService,
  xformInvSeries,
  imageService,
  Slicker,
  storageUtil,
  tdaConfig,
  zipTools,
  zip,
  InventoryGenericModule,
  cookies
) {
  var __tmplBody = Handlebars.compile(txtTemplate);
  var __tmplLoader = Handlebars.compile(txtModuleLoader);
  var __tmplStatic = Handlebars.compile(txtStatic);
  var __canDisplayInv = function canDisplayInv() {
    var participatingTda = BATSiteConfig.gxp && BATSiteConfig.gxp === 'enabled';
    // If not a participating TDA, we CAN display inventory.
    // OR if participating TDA, but zip is confirmed AND user has selected a non-gxp dealer previously
    if (!participatingTda || storageUtil.isConfirmedZip() && (cookies.getItem('dealer_code_rti') === 'false')) {
      return true;
    }
    return false;
  };

  var InventorySpecificModule = Module.extend({
    template: __tmplLoader,
    events: function () {
      return Object.assign({}, Module.prototype.events, {
        'click .module-cta-0': 'onViewClicked'
      });
    },

    staticData: {
      all: {
        subtextIcon: '/assets/img/module/inventory/icon-inventory.svg'
      },
      en: {
        // see updateStaticData for nuanced edits based on copy deck. Yahoooo
        actions: [
          {
            title: 'Default CTA Text',
            url: '/' + tdaConfig.site.context_url + '/inventory/'
          }
        ]
      },
      es: {
        actions: [
          {
            title: 'Busca en el inventario',
            url: '/' + tdaConfig.site.context_url + '/inventory/',
          }
        ]
      }
    },

    /*
      modify subtext and actions for each lang (as per copy deck)
      Doesn't work so well, because hybrid series are just 'Series'
    */
    updateStaticData: function () {
      this.staticData.en.subtext = this.result.series + ' In Stock';
      this.staticData.es.subtext = this.result.series + ' en inventario';
      this.staticData.en.copyMore = 'Near You';
      this.staticData.es.copyMore = 'Cerca de ti';
      this.staticData.en.actions[0].title = 'Browse ' + this.year + ' ' + this.result.series + ' Stock Now';
      this.staticData.en.actions[0].url = this.buildInventoryLink();
      this.staticData.es.actions[0].url = this.buildInventoryLink();
    },

    buildInventoryLink: function () {
      return '/' + tdaConfig.site.context_url + '/inventory/results/?series=' + this.seriesCode + '&grade=' + this.ctx.model.trim + '&year=' + this.ctx.model.year;
    },

    updateInventoryLinks: function (idx) {
      // use the idx from currentslide to update elems with this data
      this.ctx.model.trim = this.result.records[idx].__grade.code;
      var newLink = this.buildInventoryLink();
      $('a', this.$el).attr('href', newLink);
      var anchors = $('a', this.$el);
      // BAT-3999: HIDE THE ANCHORS AROUND IMAGE FROM SRT.
      anchors.each(function(index, item) {
        var hasImage = $(item).find('img').length;
        if (hasImage) {
          $(item).attr('aria-hidden', 'true');
          $(item).attr('tabindex', '-1');
        }
      });
    },

    initialize: function (canvas, config, idx) {
      Module.prototype.initialize.apply(this, arguments); // Call the supers initialize

      if (config.data && config.data.model && config.data.model.series && config.data.model.year) {
        var self = this;
        self.seriesCode = config.data.model.series;
        self.year = config.data.model.year;
        if (config.data.model.hasOwnProperty('trim')) {
          self.firstTrim = config.data.model.trim;
        };

        // if GXP or eventually, if inventory returns 0
        if (!__canDisplayInv()) {
          self.staticData = InventoryGenericModule.staticData;
          self.drawStatic();
        } else {
          self.request3dImages();
          self.requestInventory();

          var cacheIds = [
            '3dImages.' + self.seriesCode + '.' + self.year,
            'inventory.' + self.seriesCode + self.year
          ];

          PageCache.awaitAll(cacheIds)
            .then(function (res) {
            // console.log('awaited both, res: ', res);
              self.drawPage(res);
            })
            .catch(function (err) { console.log('err: ', err); });
        }
      }
    },

    request3dImages: function () {
      var self = this;
      var cacheId = '3dImages.' + self.seriesCode + '.' + self.year;
      if (!PageCache.has(cacheId) && !PageCache.isPending(cacheId)) {
        PageCache.maybeSet(cacheId, imageService.images().getImages({ series: self.seriesCode, year: self.year }));
      }
    },

    requestInventory: function () {
      var self = this;
      var cacheId = 'inventory.' + self.seriesCode + self.year;
      var invRequest = {
        filter: {
          region: [tdaConfig.inventory.region_code],
          series: [self.seriesCode],
          year: [self.year]
        },
        facetfields: ['grade', 'model', 'series'],
        groupmode: 'full'
      };
      if (!PageCache.has(cacheId) && !PageCache.isPending(cacheId)) {
        PageCache.maybeSet(cacheId, inventoryService.inventory().getInventory(invRequest));
      }
    },

    drawPage: function (res) {
      var self = this;
      var inv = res[1].body.response.docs[0];
      var images = res[0].DataArea.model;
      /*
      By default, the inventory service returns hybrids with regular series
      because of this, if the series doe NOT contain 'hybrid', then return only those grades that do not contain hybrids
      Need to discuss this further. see VI pages on t.com/bat, Back-end allows the selection.
      */
      if (!self.seriesCode.includes('hybrid')) {
        inv.grade = inv.grade.filter(function (obj) {
          return !obj.code.includes('hybrid');
        });
      }
      var xformOpts = {
        grade: inv.grade,
        model: inv.model,
        series: inv.series,
        images: images
      };
      if (self.hasOwnProperty('firstTrim')) {
        xformOpts.firstTrim = self.firstTrim;
      };

      var transformed = xformInvSeries(xformOpts);
      self.result = {
        records: transformed.records,
        series: transformed.series, // becomes "pretty" from the inve service
        year: self.year,
        charCountMax: 25 // TODO: Move this from ifCond in HBS to here, on a module basis. beter yet, just a boolean on trim data, so to use if, not ifCond
      };
      self.updateStaticData();
      // console.log('Inventory specific HBS obj: ', self.result);
      self.setTemplate(__tmplBody);
      self.slideShow();
      self.updateInventoryLinks(0); // need to get grade for first item (before user interacts w/ slideshow)
      self.updateModuleDataLayer();
    },

    drawStatic: function () {
      this.setTemplate(__tmplStatic);
      this.markEmpty();
    },

    markEmpty: function () {
      $(this.$el).removeClass('module-inventory-specific').addClass('module-inventory-generic module-inventory-specific-empty');
    },

    getTemplateContext: function (layout) {
      var ctx = $.extend({}, this.staticData.all, this.staticData[this.getCanvas().getLang()], this.getConfig().data);
      ctx.result = this.result; // update the context with our result
      // console.log('Final CTX for HBS: ', ctx);
      if ('3x1' === layout && ctx.result) {
        ctx.result.charCountMax = 55;
      }
      this.ctx = ctx;
      return ctx;
    },

    slideShow: function () {
      var self = this;
      var imageSlides = new Slicker({
        $slider: $('.module-slideshow', self.$el),
        slickOptions: {
          mobileFirst: true,
          fade: true,
          slide: '.module-slide',
          slidesToShow: 1,
          infinite: true,
          autoplay: false,
          arrows: true,
          dots: false,
          asNavFor: $('.module-slideshow-copy', self.$el),
          prevArrow: '<div class="mod-prev datalayer-link" data-layer=\'{"link_text": "inventory_selector_previous"}\'><button tabIndex="0" aria-label="show previous model"><i class="icon icon-arrow-thin-left"></i></button></div>',
          nextArrow: '<div class="mod-next datalayer-link" data-layer=\'{"link_text": "inventory_selector_next"}\'><button tabIndex="0" aria-label="show next model"><i class="icon icon-arrow-thin-right"></i></button></div>',
          afterFunction: function (event, slick, currentSlide) {
            self.updateInventoryLinks(currentSlide);
          }

        }
      });

      var copySlides = new Slicker({
        $slider: $('.module-slideshow-copy', self.$el),
        slickOptions: {
          mobileFirst: true,
          fade: true,
          slide: '.module-slide',
          slidesToShow: 1,
          infinite: true,
          autoplay: false,
          arrows: false,
          dots: false,
          adaptiveHeight: true,
          prevArrow: '<div class="mod-prev"><button tabIndex="0" aria-label="show previous model"><i class="icon icon-arrow-thin-left"></i></button></div>',
          nextArrow: '<div class="mod-next"><button tabIndex="0" aria-label="show next model"><i class="icon icon-arrow-thin-right"></i></button></div>'
        }
      });
    },

    resize: function () {
      Module.prototype.resize.apply(this, arguments);
      if (!__canDisplayInv()) {
        this.markEmpty();
      } else {
        this.slideShow();
      }
    },

    // if zip code changes here, we need to see if we are allowed
    // to display inventory search results
    onrender: function () {
      var self = this;
      $(window).on('ZIP_CODE_CHANGED', function () {
        if (!__canDisplayInv()) {
          self.staticData = InventoryGenericModule.staticData;
          self.drawStatic();
        }
      });
    },

    onViewClicked: function (e) {
      if (tdaConfig.tda.code == 'WWW') {
        e && e.preventDefault();
        // If we are on WWW, show the zip dialog
        zipTools.promptUserForZip(zip.getCookiedDefaultFallback(), $(e.currentTarget).attr('href'));
      }
    },

    // there's a default dataLayer output on parent .module
    // take that and supplement it with our inventory data.
    updateModuleDataLayer: function () {
      var $parent = this.$el;
      var dataToAdd = {
        series_code: this.seriesCode,
        series_year: this.year,
        series_number: this.seriesCode,
        series_vehicleid: '',
        series_inventory_type: 'New',
        series_brand: 'Toyota',
        series_category: '',
        series_fuel_type: '',
        series_msrp: '',
        series_grade: '',
        series_engine: '',
        series_transmission: '',
        series_body_style: '',
        series_packages: '',
        series_color_ext: '',
        series_color_int: '',
        series_color_ext_code: '',
        series_color_int_code: '',
        series_accessories_name: '',
      };
      var data = $parent.data('layer') || {};
      if (typeof data !== 'object') {
        data = JSON.parse(data);
      }
      // update data on parent module
      var fullData = Object.assign({}, data, dataToAdd);
      $parent.data('layer', fullData);
    }
  });

  return InventorySpecificModule;
});

